module.exports = __webpack_public_path__ + "img/issues.e8d4e44e.svg";